import {I18n} from '@aws-amplify/core';
import {Code, Group, Stack, Text, Title} from "@mantine/core";
import {PlatformPropertyCardCopyButtonDecorator} from "@flexinet/ui-components";
import {BindingDriftReport} from "../types.ts";
import {FindingsTable} from "./FindingsTable.tsx";
import {parseFindings} from "../utils/parseFindings.ts";

// The per-account drift detail for one run — the right panel of the detail page.
export const FindingsPanel = ({record}: { record: BindingDriftReport }) => {
    const findings = parseFindings(record.findings);

    return (
        <Stack gap={'xs'}>
            <Title order={5}>{I18n.get('Per-account findings')}</Title>
            {findings.length > 0
                ? <FindingsTable findings={findings}/>
                : <Text c={'dimmed'} size={'sm'}>{I18n.get('No per-account findings for this run.')}</Text>}
            {record.findingsS3Uri
                ? <Stack gap={4}>
                    <Text size={'xs'} c={'dimmed'}>{I18n.get('Full findings overflowed inline storage:')}</Text>
                    {/* FNP-593: an s3:// URI has no browser handler, so an Anchor href
                        was a dead link. Render it as copyable monospace text instead —
                        the operator can paste it into the AWS console / CLI. */}
                    <Group gap={'xs'} wrap={'nowrap'} align={'center'}>
                        <Code>{record.findingsS3Uri}</Code>
                        <PlatformPropertyCardCopyButtonDecorator value={record.findingsS3Uri}/>
                    </Group>
                </Stack>
                : null}
        </Stack>
    );
};
